const ITEMS = [
  "Prophetic Ministry",
  "Kingdom Associates",
  "Spiritual Warfare",
  "Holistic Wellness",
  "Coaching & Mentorship",
  "Books & Resources",
  "Leadership Development",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div data-testid="editorial-marquee" className="relative z-10 border-y border-white/5 bg-white/[0.015] py-6 overflow-hidden">
      <div className="flex whitespace-nowrap animate-marquee w-max">
        {row.map((item, i) => (
          <span key={i} className="mx-7 flex items-center gap-12 font-display text-2xl sm:text-3xl font-bold uppercase tracking-tight text-slate-700">
            {item}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-violet-400 to-amber-400 text-xl">&#10022;</span>
          </span>
        ))}
      </div>
    </div>
  );
}
